module.exports = __webpack_public_path__ + "static/media/Vector_4.c402a785.png";